"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modal = exports.modal_io = void 0;
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
var widget_1 = require("../basics/widget");
/**
 * @deprecated Don't use directly, use the [[modal]] function instead.
 * @todo maybe change it to `React.FunctionComponent` and hooks, since currently it has not state.
 */
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props, context) {
        var _this = _super.call(this, props, context) || this;
        // this.state = { value:props.input } // DEAD CODE
        _this.el = document.createElement('div');
        return _this;
    }
    Modal.prototype.componentDidMount = function () {
        this.props.modal_root.appendChild(this.el);
    };
    Modal.prototype.componentWillUnmount = function () {
        this.props.modal_root.removeChild(this.el);
    };
    Modal.prototype.render = function () {
        var _this = this;
        return ReactDOM.createPortal(this.props.inner_widget(this.props.input).run(function (o) { return _this.props.on_done(o); }), this.el);
    };
    return Modal;
}(React.Component));
/**  This is the lifted version of [[modal]]
 * This means instead of operating on a [Widget], it operates on an [[IOWidget]]
 */
var modal_io = function (modal_root_id) {
    var modal_root = document.getElementById(modal_root_id);
    return function (inner_widget) { return function (input) { return (0, widget_1.fromJSX)(function (on_done) {
        return React.createElement(Modal, { on_done: on_done, inner_widget: inner_widget, input: input, modal_root: modal_root });
    }); }; };
};
exports.modal_io = modal_io;
/**
 * It allows you to mount a given `widget` to be rendered in a different place inside the DOM than its parent widget.
 * Underneath it uses the similar in-purpose `ReactDOM.createPortal`.
 * @param modal_root_id
 */
var modal = function (modal_root_id) {
    return function (widget) { return (0, exports.modal_io)(modal_root_id)(function (_) { return widget; })({}); };
};
exports.modal = modal;
